import React from "react";

/* Form & Form Validation */
import * as Yup from "yup";

import { Form, Input, Select, Switch, Checkbox } from "formik-antd";
import { Divider } from "antd";

import { InputDateTime } from "../../../../core/components/form";

import { DATETIME_FORMAT } from "../../../../core/utils/i18n-js";

import { createDate, nowWithTimezone } from "../../../../core/utils/timezones";
import ModalForm from "../../../../core/components/form/modalForm";
import FormServiceSelector from "../../../../components/service/form/selector";

import { QTASK_RUSH_TYPES, QTASK_RUSH_TYPE_NONE } from "../../../../config/const";

const ValidationSchema = Yup.object().shape({
    service: Yup.string().nullable().required("Cannot be blank."),
    languageType: Yup.string().nullable().required("Cannot be blank."),
    language: Yup.string().when(["languageType", "languageFamily"], {
        is: (languageType, languageFamily) =>
            languageType == "Single" && languageFamily != "LTR" && languageFamily != "RTL",
        then: Yup.string().required("Cannot be blank"),
    }),
    /*
    language: Yup.string().when("languageType", {
        is: "Single",
        then: (fieldSchema) => fieldSchema.required("Cannot be blank."),
    }),*/
    languagePair: Yup.string().when("languageType", {
        is: "Pair",
        then: (fieldSchema) => fieldSchema.required("Cannot be blank."),
    }),
    isWord: Yup.bool().required(),
    catlog: Yup.string().when("isWord", {
        is: true,
        then: (fieldSchema) => fieldSchema.required("Cannot be blank."),
    }),
    unit: Yup.string().when("isWord", {
        is: false,
        then: (fieldSchema) => fieldSchema.required("Cannot be blank."),
    }),
    amount: Yup.number()
        .typeError("Must be a number")
        .when("isWord", {
            is: false,
            then: (fieldSchema) => fieldSchema.required("Cannot be blank."),
        }),
    /*
    deadlineAt: Yup.date().required("Cannot be blank.").typeError("Must be a date"),
    */
});

const _filter = (input, option) => option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;

const catlogs = [
    { value: 1, label: "XTM Excel" },
    { value: 2, label: "Salesforce CSV" },
];

const Formulario = (props) => {
    const editing = props.task?.id > 0;
    const _initialForm = () => {
        const { task } = props;

        if (task) {
            /*
            const deadlineAt = createDate(task.deadlineAt, task.deadlineAtTimezone);
            */
            return {
                /*
                code: task.code,
                */
                service: task.service.id,
                category: task.serviceCategory?.id,
                language: task.language?.id,
                languageType: task.languageType,
                languageFamily: task.languageFamily,
                languagePair: task.languagePair?.id,
                /*
                deadlineAt: deadlineAt,
                */
                isWord: task.isWord,
                catlog: task.isWord ? task.catlog.id : "",
                unit: task.baseUnit ? task.baseUnit.id : "",
                amount: !task.isWord ? task.baseUnitAmount : "",
                notes: task?.notes,
                rushType: task.rushType,
            };
        } else {
            return {
                /*
                code: "",
                */
                service: "",
                category: "",
                language: "",
                languageFamily: "",
                languageType: "Pair",
                languagePair: "",
                /*
                deadlineAt: nowWithTimezone(),
                */
                isWord: false,
                catlog: "",
                unit: "",
                amount: "",
                notes: "",
                rushType: QTASK_RUSH_TYPE_NONE,
            };
        }
    };

    const catlogEnable = (catlogs) => {
        return catlogs.filter((e) => props.catlogs.some((c) => c.id == e.value));
    };

    return (
        <ModalForm
            loading={props.loading}
            title="Task"
            initialValues={_initialForm()}
            onCancel={props.handleCancel}
            validationSchema={ValidationSchema}
            onSubmit={props.handleSubmit}
            visible={props.visible}
            width={700}
            render={({ isSubmitting, setFieldValue, touched, errors, values }) => (
                <>
                    {/*
                    <Form.Item label="Code" name="code" hasFeedback={true} showValidateSuccess={true} required>
                        <Input name="code" placeholder="Code #" />
                    </Form.Item>
                */}

                    <FormServiceSelector formik={{ isSubmitting, touched, setFieldValue, values, errors }} />

                    {!values.isWord && (
                        <Form.Item label="Unit Amount" name="amount" hasFeedback={true} showValidateSuccess={true}>
                            <Input name="amount" placeholder="Amount" />
                        </Form.Item>
                    )}

                    {values.isWord && (
                        <Form.Item label="CAT Format" name="catlog" hasFeedback={true} showValidateSuccess={true}>
                            <Select
                                placeholder="CAT Format"
                                name="catlog"
                                showSearch
                                options={catlogEnable(catlogs)}
                                filterOption={_filter}
                            />
                        </Form.Item>
                    )}

                    {/*
                    <InputDateTime
                        name="deadlineAt"
                        label="DDL"
                        placeholder="Deadline At"
                        errors={errors.deadlineAt}
                        touched={touched.deadlineAt}
                        ayout="horizontal"
                        showTime={{ format: "HH:mm", minuteStep: 15 }}
                        format={DATETIME_FORMAT}
                        defaultTimezone={values.deadlineAt ? values.deadlineAt.tz() : null}
                        required={true}
                    />
*/}

                    {/*
                    <Form.Item label="Rush" name="rushType" hasFeedback={true} showValidateSuccess={true}>
                        <Select placeholder="Rush" name="rushType">
                            {TASK_RUSH_TYPES.map((e) => (
                                <Select.Option value={e}>{e}</Select.Option>
                            ))}
                        </Select>
                    </Form.Item>
*/}
                    <Form.Item label="Notes" name="notes" hasFeedback={true}>
                        <Input.TextArea name="notes" placeholder="Notes" />
                    </Form.Item>

                    <Divider plain />
                </>
            )}
        />
    );
};

export default Formulario;
